module.exports = __webpack_public_path__ + "static/SquareSerif-Medium-webfont-b337c480cac2a081bb7a030cfb606cff.woff2";